import React from 'react';
import {Box} from "@chakra-ui/react"
import Home from "./pages/Home"
import {Routes, Route} from "react-router-dom"
import NotFound from "./componetns/NotFound";
// style
import "./styles/index.css"
import "./componetns/style/style.css"
const App = () => {
    return (
        <Box className="App">
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </Box>
    );
};

export default App;
